import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 gap-y-8 gap-x-4 mb-8" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium mb-1" }, "Pool Name", -1)
const _hoisted_4 = { class: "style-input-without-border rounded-lg" }
const _hoisted_5 = { class: "font-medium mb-1" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Pool Symbol ")
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "style-input-without-border rounded-lg" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center h-full ml-2" }, " WPT- ", -1)
const _hoisted_10 = { class: "grid grid-cols-1 md:grid-cols-2 gap-y-8 gap-x-4 mb-8" }
const _hoisted_11 = { class: "font-medium mb-1" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Swap Fee Percentage ")
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "style-input-without-border rounded-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalTextInput = _resolveComponent("BalTextInput")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalTooltip = _resolveComponent("BalTooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_BalTextInput, {
            name: "poo-name",
            "model-value": _ctx.poolName,
            onInput: _cache[0] || (_cache[0] = value => _ctx.emit('poolNameChange', value)),
            type: "text",
            "validate-on": "input",
            "prepend-border": "",
            "no-margin": true
          }, null, 8, ["model-value"])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_BalTooltip, null, {
            activator: _withCtx(() => [
              _createVNode(_component_BalIcon, {
                name: "info",
                size: "sm",
                class: "ml-1 text-gray-400 -mb-px"
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: _ctx.poolSymbolInfoText,
                class: "w-52"
              }, null, 8, _hoisted_7)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_BalTextInput, {
            name: "pool-symbol",
            "model-value": _ctx.poolSymbol,
            isValid: _ctx.poolSymbolValid,
            "onUpdate:isValid": _cache[1] || (_cache[1] = ($event: any) => (_ctx.poolSymbolValid = $event)),
            onInput: _cache[2] || (_cache[2] = value => _ctx.emit('poolSymbolChange', value)),
            type: "text",
            "validate-on": "input",
            "prepend-border": "",
            "no-margin": true,
            rules: [_ctx.maxChar(20), _ctx.isSymbol()]
          }, {
            prepend: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["model-value", "isValid", "rules"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_BalTooltip, null, {
            activator: _withCtx(() => [
              _createVNode(_component_BalIcon, {
                name: "info",
                size: "sm",
                class: "ml-1 text-gray-400 -mb-px"
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: _ctx.swapFeePercentageInfoText,
                class: "w-52"
              }, null, 8, _hoisted_13)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_BalTextInput, {
            name: "swap-fee-percentage",
            "model-value": _ctx.swapFeePercentage,
            onInput: _cache[3] || (_cache[3] = value => _ctx.emit('poolSwapFeePercentageChange', value)),
            type: "number",
            "validate-on": "input",
            "prepend-border": "",
            "no-margin": true,
            rules: [_ctx.isGreaterThanOrEqualTo(0.0001), _ctx.isLessThanOrEqualTo(10)],
            isValid: _ctx.swapFeePercentageValid,
            "onUpdate:isValid": _cache[4] || (_cache[4] = ($event: any) => (_ctx.swapFeePercentageValid = $event))
          }, null, 8, ["model-value", "rules", "isValid"])
        ])
      ])
    ])
  ], 64))
}